import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {deleteApi, getApi, postApi, putApi} from "../../utils/axios-client";
import * as React from "react";
interface PersonalInformationData {
}

interface mobileNumberObject {
    mobileNumberData:object;
    mobileNumber: string;
    mobileNumberValid: boolean;
    isEditMobileMode:boolean;
    updatedMobileNumber: string;
    isGetPhoneNumberLoaded:boolean;
    isGetPhoneNumberLoadedRejected: boolean;
    isUpdatePhoneNumberLoaded:boolean;
    isUpdatePhoneNumberRejected: boolean;
    isSavePhoneNumberLoaded:boolean;
    isSavePhoneNumberRejected: boolean;
    activationCode: string;
    isActivationCodeLoaded: boolean;
    isSubmitActivationCodeLoaded: boolean;
    isSubmitActivationCodeRejected: boolean;
    isShowToggleButton: boolean;
    showSignUpForTextAlertsButton: boolean;
}

interface emailAddressObject {
    emailAddressData:object;
    emailAddress: string;
    undeliverable: boolean;
    emailAddressValid: boolean;
    updatedEmailAddress: string;
    isEditEmailMode: boolean;
    isGetEmailAddressLoaded: boolean;
    isGetEmailAddressLoadedRejected: boolean;
    isUpdateEmailAddressLoaded: boolean;
    isUpdateEmailAddressRejected: boolean;
    isEditSubscriptionEmail: boolean;
    updatedSubscriptionEmail: string;
    isSubscriptionEmailValid: boolean;
    isSubscriptionEmailError: boolean;
    isEmailNotOnFileError: boolean;
    isEmailAddressError: boolean;
}

interface planningInfoData {
    isEditPlanInfoMode: boolean;
    retirementIncomeScenario: object;
    isRixScenarioLoaded: boolean;
    isRixScenarioRejectedDataLoaded: boolean;
    compensations: object;
    compensationsDataLoaded: boolean;
    compensationsDataRejected: boolean;
    isUpdateCompensationsLoaded: boolean;
    isUpdateCompensationsRejected: boolean;
    isSaveRixSalaryPayFrequencyLoaded: boolean;
    isSaveRixSalaryPayFrequencyRejected: boolean;
    isSaveOrUpdateRiSimulationLoaded: boolean;
    isSaveOrUpdateRiSimulationRejected: boolean;
    updatedAnnualSalary: number;
    multiClientCompensation: boolean;
    updatedRetirementAge: number;
    updatedMarginalTaxRate: number;
    updatedPaycheckFrequency: string;
    paycheckFrequencyOptions: object;
    taxRateBrackets: object;
    isAnnualSalaryError: boolean;
    isRetirementAgeError: boolean;
    isMarginalTaxRateError: boolean;
    isSavePlanInfoRejected: boolean;
}

interface aboutYourselfData {
    isEditAboutYourselfData: boolean;
    investmentExpOptions: object;
    investmentGoalOptions: object;
    isGetReferenceTypeValuesLoaded: boolean;
    isGetReferenceTypeValuesLoadedRejected: boolean;
    gender: object;
    investmentExpLevel: object;
    investmentGoals: object;
    updatedGender: object;
    updatedInvestmentExpLevel: object;
    updatedInvestmentGoals: object;
}

interface PersonalInformationState {
    plansData: object;
    selectedPlan: {value?: string, label?: React.ReactNode},
    isPlansDataLoaded: boolean;
    personalInformationData: PersonalInformationData;
    isPersonalInformationDataLoaded: boolean;
    isPersonalInformationDataLoadedRejected: boolean;
    planProfileOlaMessageData: object;
    isPlanProfileOlaMessageDataLoaded: boolean;
    isPlanProfileOlaMessageDataLoadedRejected: boolean;

    sempraActivePlanNameOlaMsg :object;
    isSempraActivePlanNameOlaMsgDataLoaded: boolean;
    isSempraActivePlanNameOlaMsgDataLoadedRejected: boolean;

    sempraTerminatedPlanNameOlaMsg :object;
    isSempraTerminatedPlanNameOlaMsgDataLoaded: boolean;
    isSempraTerminatedPlanNameOlaMsgDataLoadedRejected: boolean;

    plansInfoData: object;
    isPlansInfoDataLoaded: boolean;
    isPlansInfoDataLoadedRejected: boolean;
    plansRulesData: object;
    isPlansRulesDataLoaded: boolean;
    isPlansRulesDataLoadedRejected: boolean;
    participantBeneficiaryData: object;
    isParticipantBeneficiaryDataLoaded: boolean;
    isParticipantBeneficiaryDataRejected: boolean;
    definedBenefitParticipantBeneficiariesData: object;
    isDefinedBenefitParticipantBeneficiariesDataLoaded: boolean;
    isDefinedBenefitParticipantBeneficiariesDataLoadedRejected: boolean;
    beneMcCAmishSwitchData: object;
    isBeneMcCAmishSwitchDataLoaded: boolean;
    isBeneMcCAmishSwitchDataLoadedRejected: boolean;
    alwaysChallenge: boolean;
    isPricesInvOptionsChecked: boolean;
    selectedPricesServiceProducts: object;
    isPerformanceInvOptionsChecked: boolean;
    selectedPerformanceServiceProducts: object;
    isDailyPricesInvestmentError: boolean;
    isMonthlyPerformanceInvestmentError: boolean;
    isProfileMfaDataLoaded: boolean;
    isProfileMfaDataRejected: boolean;
    loading: string;
    currentScreen: string;
    currentRequestId: string | undefined;
    error: Error | null;
    emailAddressObject: emailAddressObject;
    mobileNumberObject: mobileNumberObject;
    clientProfile: object;
    isClientProfileLoaded: boolean;
    isClientProfileRejectedDataLoaded: boolean;
    isSaveOrUpdateClientProfileLoaded: boolean;
    isSaveOrUpdateClientProfileRejected: boolean;
    participantConsentData: any;
    isParticipantConsentDataLoaded: boolean;
    isParticipantConsentDataRejected: boolean;
    taxRateBrackets: object;
    isTaxRateBracketsDataLoaded: boolean;
    isTaxRateBracketsDataRejected: boolean;
    planningInformation: planningInfoData;
    aboutYourselfData: aboutYourselfData;
    userPreferences: any,
    participantTerminateOlaMessageData: object;
    isParticipantTerminateOlaMessageDataLoaded: boolean;
    isParticipantTerminateOlaMessageDataLoadedRejected: boolean;
    otherRetirementPlanData: object;
    isOtherRetirementPlanDataLoaded: boolean;
    isOtherRetirementPlanDataRejected: boolean;
    isShowOrHideOtherRetirementPlansLoaded: boolean;
    isShowOrHideOtherRetirementPlansRejected: boolean;
    serviceStatus: object;
    dailyPricesInvOption: string;
    monthlyPerformanceInvOption: string;
    addConsentRequestData: any;
    serviceStatusDailyPricesRequestData: any;
    serviceProductDailyPricesRequestData:any;
    serviceStatusMonthlyPerformanceRequestData: any;
    serviceProductMonthlyPerformanceRequestData:any;
    isServiceStatusDataLoaded: boolean;
    isServiceStatusDataRejected: boolean;
    filteredPlanProducts: object;
    serviceProducts: object;
    isPlanProductsDataLoaded: boolean;
    isPlanProductsDataRejected: boolean;
    isServiceProductsDataLoaded: boolean;
    isServiceProductsDataRejected: boolean;
    saveDailyPricesPreferences: boolean;
    saveDailPricesInvestmentOptions: boolean;
    saveMonthlyPerformanceInvestmentOptions: boolean;
    saveMonthlyPerformancePreferences: boolean;
    putServiceCallForDailyPrices:boolean;
    putServiceCallForMonthlyPerformance:boolean;
    deleteServiceCallForDailyPrices:boolean;
    deleteServiceCallForMonthlyPerformance:boolean;
    isShowSaveModal: boolean;
    refreshPreferencesAndSubscription : boolean;
    isSavePrefAndSubCallRejected: boolean;
    navigateToPreferencesAndSubscription: boolean;
    isSempraPlan: boolean;
}

const initialState: PersonalInformationState = {
    plansData: [],
    selectedPlan: {},
    isPlansDataLoaded: false,
    loading: 'idle',
    currentScreen: 'PROFILE',
    currentRequestId: undefined,
    error: null ,
    personalInformationData: {} as PersonalInformationData,
    isPersonalInformationDataLoaded: false,
    isPersonalInformationDataLoadedRejected: false,
    planProfileOlaMessageData: {},
    isPlanProfileOlaMessageDataLoaded: false,
    isPlanProfileOlaMessageDataLoadedRejected: false,

    sempraActivePlanNameOlaMsg :{},
    isSempraActivePlanNameOlaMsgDataLoaded: false,
    isSempraActivePlanNameOlaMsgDataLoadedRejected: false,
    sempraTerminatedPlanNameOlaMsg : {},
    isSempraTerminatedPlanNameOlaMsgDataLoaded: false,
    isSempraTerminatedPlanNameOlaMsgDataLoadedRejected: false,

    beneMcCAmishSwitchData: {},
    isBeneMcCAmishSwitchDataLoaded: false,
    isBeneMcCAmishSwitchDataLoadedRejected: false,
    plansInfoData: {},
    isPlansInfoDataLoaded: false,
    isPlansInfoDataLoadedRejected: false,
    plansRulesData: {},
    isPlansRulesDataLoaded: false,
    isPlansRulesDataLoadedRejected: false,
    participantBeneficiaryData: {
        beneficiaryArray: []
    },
    isParticipantBeneficiaryDataLoaded: false,
    isParticipantBeneficiaryDataRejected: false,
    definedBenefitParticipantBeneficiariesData: {},
    isDefinedBenefitParticipantBeneficiariesDataLoaded: false,
    isDefinedBenefitParticipantBeneficiariesDataLoadedRejected: false,
    alwaysChallenge: false,
    isPricesInvOptionsChecked: false,
    selectedPricesServiceProducts: [],
    isPerformanceInvOptionsChecked: false,
    selectedPerformanceServiceProducts: [],
    isDailyPricesInvestmentError: false,
    isMonthlyPerformanceInvestmentError: false,
    isProfileMfaDataLoaded: false,
    isProfileMfaDataRejected: false,
    emailAddressObject: {
        emailAddressData:{},
        emailAddress: '',
        undeliverable: false,
        updatedEmailAddress: '',
        emailAddressValid: false,
        isEditEmailMode: false,
        isGetEmailAddressLoaded: false,
        isGetEmailAddressLoadedRejected: false,
        isUpdateEmailAddressLoaded: false,
        isUpdateEmailAddressRejected: false,
        isEditSubscriptionEmail: false,
        updatedSubscriptionEmail: '',
        isSubscriptionEmailValid: false,
        isSubscriptionEmailError: false,
        isEmailNotOnFileError: false,
        isEmailAddressError: false
    } as emailAddressObject,
    mobileNumberObject: {
        mobileNumberData:{},
        mobileNumber: '',
        mobileNumberValid:false,
        isEditMobileMode:false,
        updatedMobileNumber:'',
        isGetPhoneNumberLoaded:false,
        isGetPhoneNumberLoadedRejected: false,
        isUpdatePhoneNumberLoaded:false,
        isUpdatePhoneNumberRejected: false,
        isSavePhoneNumberLoaded:false,
        isSavePhoneNumberRejected: false,
        activationCode: '',
        isActivationCodeLoaded: false,
        isSubmitActivationCodeLoaded: false,
        isSubmitActivationCodeRejected: false,
        isShowToggleButton: false,
        showSignUpForTextAlertsButton: false,
    } as mobileNumberObject,
    clientProfile: {},
    isClientProfileLoaded: false,
    isClientProfileRejectedDataLoaded:false,
    isSaveOrUpdateClientProfileLoaded: false,
    isSaveOrUpdateClientProfileRejected: false,
    aboutYourselfData: {
        isEditAboutYourselfData: false,
        investmentExpOptions: [],
        isGetReferenceTypeValuesLoaded: false,
        isGetReferenceTypeValuesLoadedRejected: false,
        investmentGoalOptions: [],
        gender: [],
        investmentExpLevel: [],
        investmentGoals: [],
        updatedGender: [],
        updatedInvestmentExpLevel: [],
        updatedInvestmentGoals: []
    } as aboutYourselfData,
    planningInformation: {
        isEditPlanInfoMode: false,
        retirementIncomeScenario: [],
        isRixScenarioLoaded: false,
        isRixScenarioRejectedDataLoaded:false,
        compensations: [],
        compensationsDataLoaded: false,
        compensationsDataRejected: false,
        isUpdateCompensationsLoaded: false,
        isUpdateCompensationsRejected: false,
        isSaveRixSalaryPayFrequencyLoaded: false,
        isSaveRixSalaryPayFrequencyRejected: false,
        isSaveOrUpdateRiSimulationLoaded: false,
        isSaveOrUpdateRiSimulationRejected: false,
        multiClientCompensation: false,
        paycheckFrequencyOptions: [],
        taxRateBrackets: [],
        isAnnualSalaryError: false,
        isRetirementAgeError: false,
        isMarginalTaxRateError: false,
        isSavePlanInfoRejected: false,
    } as planningInfoData,
    participantConsentData: [],
    isParticipantConsentDataLoaded: false,
    isParticipantConsentDataRejected: false,
    taxRateBrackets: [],
    isTaxRateBracketsDataLoaded: false,
    isTaxRateBracketsDataRejected: false,
    userPreferences: {},
    participantTerminateOlaMessageData: {},
    isParticipantTerminateOlaMessageDataLoaded: false,
    isParticipantTerminateOlaMessageDataLoadedRejected: false,
    otherRetirementPlanData: {
        otherRetirementPlans:null,
        showOldRetirementPlans:false,
    },
    isOtherRetirementPlanDataLoaded:false,
    isOtherRetirementPlanDataRejected: false,
    isShowOrHideOtherRetirementPlansLoaded: false,
    isShowOrHideOtherRetirementPlansRejected: false,
    serviceStatus: [],
    dailyPricesInvOption: "",
    monthlyPerformanceInvOption: "",
    isServiceStatusDataLoaded: false,
    isServiceStatusDataRejected: false,
    filteredPlanProducts: [],
    serviceProducts: [],
    isPlanProductsDataLoaded: false,
    isPlanProductsDataRejected: false,
    isServiceProductsDataLoaded: false,
    isServiceProductsDataRejected: false,
    addConsentRequestData: [],
    serviceStatusDailyPricesRequestData: [],
    serviceStatusMonthlyPerformanceRequestData:[],
    serviceProductDailyPricesRequestData: [],
    serviceProductMonthlyPerformanceRequestData:[],
    saveDailyPricesPreferences: false,
    saveMonthlyPerformancePreferences: false,
    saveDailPricesInvestmentOptions:false,
    saveMonthlyPerformanceInvestmentOptions:false,
    putServiceCallForDailyPrices:false,
    putServiceCallForMonthlyPerformance:false,
    deleteServiceCallForDailyPrices:false,
    deleteServiceCallForMonthlyPerformance:false,
    isShowSaveModal : false,
    refreshPreferencesAndSubscription : false,
    isSavePrefAndSubCallRejected: false,
    navigateToPreferencesAndSubscription: false,
    isSempraPlan: false
}

export const getPlansData =  createAsyncThunk(
    'getPlansData',
    async (_, {rejectWithValue}) => {
        try {
            const response =   await getApi('getPlansData','?sorted=true');
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const getPersonalInformationData =  createAsyncThunk(
    'getPersonalInformationData',
    async (planNumber, { rejectWithValue }) => {
        try {
            const response =   await getApi('getPersonalInformationData',`?planNumber=${planNumber}`);
             return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const getPhoneNumber =  createAsyncThunk(
    'getPhoneNumber',
    async (planNumber,{ rejectWithValue }) => {
        try {
            const response =   await getApi('getPhoneNumber',`?planNumber=${planNumber}`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const updatePhoneNumber =  createAsyncThunk(
    'updatePhoneNumber',
    async ({mobileNumber, planNumber},thunkConfig) => {
        try {
            const requestBodyPhoneNumber = {
                "participantPhoneNumber": mobileNumber.split('-').join(""),
                "planNumber": planNumber
            }
            const response =   await putApi('savePhoneNumber',`?planNumber=${planNumber}`,requestBodyPhoneNumber);
            thunkConfig.dispatch(setMobileNumber(mobileNumber));
            thunkConfig.dispatch(setIsEditMobileMode(false));
            thunkConfig.dispatch(setUpdatedMobileNumber(''));
            thunkConfig.dispatch(setMobileNumberValid(false));
            return response;
        } catch (err){
            return thunkConfig.rejectWithValue(err.response.data)
        }

    }
)

export const savePhoneNumber =  createAsyncThunk(
    'savePhoneNumber',
    async ({mobileNumber, planNumber },thunkConfig) => {
        try {
            const requestBodyPhoneNumber = {
                "participantPhoneNumber": mobileNumber.split('-').join(""),
                "planNumber": planNumber
            }
            const response =   await postApi('savePhoneNumber',`?planNumber=${planNumber}`,requestBodyPhoneNumber);
            thunkConfig.dispatch(setMobileNumber(mobileNumber));
            thunkConfig.dispatch(setIsEditMobileMode(false));
            thunkConfig.dispatch(setUpdatedMobileNumber(''));
            thunkConfig.dispatch(setMobileNumberValid(false));
            return response;
        } catch (err){
            return thunkConfig.rejectWithValue(err.response.data)
        }

    }
)

export const getActivationCode =  createAsyncThunk(
    'getActivationCode',
    async ({mobileNumber, planNumber} ,thunkConfig) => {
        try {
            const requestBodyData = {
                "participantPhoneNumber": mobileNumber.split('-').join(""),
                "planNumber": planNumber,
                "origin": "profile",
            }
            const response =   await postApi('getActivationCode','',requestBodyData);
            return response;
        } catch (err){
            return thunkConfig.rejectWithValue(err.response.data)
        }

    }
)

export const submitActivationCode = createAsyncThunk(
    'submitActivationCode',
    async ({mobileNumber, planNumber, code } ,thunkAPI) => {
        try {
            const requestBodyData = {
                "participantPhoneNumber": mobileNumber.split('-').join(""),
                "planNumber": planNumber,
                "activationCode": code.toString()
            }
            const response =   await postApi('submitActivationCode','',requestBodyData);
            return response;
        } catch (err) {
            if (err.response) {
                return thunkAPI.rejectWithValue(err.response.data);
            } else {
                throw err;
            }
        }

    }
)

export const getEmailAddress =  createAsyncThunk(
    'getEmailAddress',
    async (planNumber,{ rejectWithValue }) => {
        try {
            const response =   await getApi('getEmailAddress',`?planNumber=${planNumber}`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }
    }
)

export const updateEmailAddress =  createAsyncThunk(
    'updateEmailAddress',
    async ({emailAddress, planNumber },thunkConfig) => {
        try {
            const requestBodyEmailAddress = {
                "emailAddress": emailAddress,
                "planNumber": planNumber
            }
            const response =   await putApi('updateEmailAddress','',requestBodyEmailAddress);
            thunkConfig.dispatch(setEmailAddress(emailAddress));
            thunkConfig.dispatch(setIsEditEmailMode(false));
            thunkConfig.dispatch(setIsEditSubscriptionEmail(false));
            thunkConfig.dispatch(setEmailAddressValid(false));
            thunkConfig.dispatch(setIsEmailNotOnFileError(false));
            return response;
        } catch (err){
            return thunkConfig.rejectWithValue(err.response.data)
        }

    }
)

export const getPlanProfileOlaMessageData =  createAsyncThunk(
    'getPlanProfileOlaMessageData',
    async (planNumber, { rejectWithValue }) => {
        try {
            const response =   await getApi('getPlanProfileOlaMessageData',`?planNumber=${planNumber}&messageID=40153`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const getSempraActivePlanNameOlaMsg =  createAsyncThunk(
    'getSempraActivePlanNameOlaMsg',
    async (planNumber, { rejectWithValue }) => {
        try {
            const response =   await getApi('getSempraActivePlanNameOlaMsg',`?planNumber=${planNumber}&messageID=65660`);
            console.log("sempra response");
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const getSempraTerminatedPlanNameOlaMsg =  createAsyncThunk(
    'getSempraTerminatedPlanNameOlaMsg',
    async (planNumber, { rejectWithValue }) => {
        try {
            const response =   await getApi('getSempraTerminatedPlanNameOlaMsg',`?planNumber=${planNumber}&messageID=65661`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const getParticipantTerminateOlaMessageData =  createAsyncThunk(
    'getParticipantTerminateOlaMessageData',
    async (planNumber, { rejectWithValue }) => {
        try {
            const response =   await getApi('getParticipantTerminateOlaMessageData',`?planNumber=${planNumber}&messageID=65640`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const getBeneMcCAmishSwitchData =  createAsyncThunk(
    'getBeneMcCAmishSwitchData',
    async (planNumber, { rejectWithValue }) => {
        try {
            const response =   await getApi('getBeneMcCAmishSwitchData',`?planNumber=${planNumber}&messageID=40109`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)
export const getPlansInfoData =  createAsyncThunk(
    'getPlansInfoData',
    async (planNumber,{ rejectWithValue }) => {
        try {
            const response =   await getApi('getPlansInfoData',`&planNumber=${planNumber}`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const getPlansRulesData =  createAsyncThunk(
    'getPlansRulesData',
    async (planNumber,{ rejectWithValue }) => {
        try {
            const response =   await getApi('getPlansRulesData',`&planNumber=${planNumber}`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const getParticipantBeneficiaryData =  createAsyncThunk(
    'getParticipantBeneficiaryData',
    async (planNumber,{ rejectWithValue }) => {
        try {
            const requestBody = {
                "planNumber": planNumber
            }
            const response =   await postApi('getParticipantBeneficiaryData','', requestBody);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const getDefinedBenefitParticipantBeneficiariesData =  createAsyncThunk(
    'getDefinedBenefitParticipantBeneficiariesData',
    async (planNumber,{ rejectWithValue }) => {
        try {
            const response =   await getApi('getDefinedBenefitParticipantBeneficiariesData',`/${planNumber}`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const getClientProfile =  createAsyncThunk(
    'getClientProfile',
    async (_,{ rejectWithValue }) => {
        try {
            const response =   await getApi('getClientProfile','');
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }
    }
)

export const getReferenceTypeValues =  createAsyncThunk(
    'getReferenceTypeValues',
    async (typeId,{ rejectWithValue }) => {
        try {
            const response =   await getApi('getReferenceTypeValues',`?ID=${typeId}`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const saveOrUpdateClientProfile =  createAsyncThunk(
    'saveOrUpdateClientProfile',
    async ({profile, profileAlreadyExists },thunkConfig) => {
        try {
            let response;
            if(profileAlreadyExists)
                response = await putApi('saveOrUpdateClientProfile','',profile);
            else
                response = await postApi('saveOrUpdateClientProfile','',profile);
            thunkConfig.dispatch(setIsEditAboutYourselfData(false));
            thunkConfig.dispatch(setClientProfile(profile));
            return response;
        } catch (err){
            return thunkConfig.rejectWithValue(err.response.data)
        }

    }
)

export const getRixScenario =  createAsyncThunk(
    'getRixScenario',
    async (_,{ rejectWithValue }) => {
        try {
            const response =   await getApi('getRixScenario','');
            return response;
        } catch (err){
            return rejectWithValue(err.response.data);
        }
    }
)

export const getCompensations =  createAsyncThunk(
    'getCompensations',
    async (_,{ rejectWithValue }) => {
        try {
            const response =   await getApi('getCompensations','');
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const updateCompensations = createAsyncThunk(
    'updateCompensations',
    async ({compensations},thunkConfig) => {
        try {
            const response = await postApi('updateCompensations','',compensations);
            thunkConfig.dispatch(setCompensations(compensations));
            return response;
        } catch (err){
            return thunkConfig.rejectWithValue(err.response.data)
        }
    }
)

export const saveRixSalaryPayFrequency = createAsyncThunk(
    'saveRixSalaryPayFrequency',
    async ({userEnteredCompensation},thunkConfig) => {
        try {
            const response = await putApi('saveRixSalaryPayFrequency','',userEnteredCompensation);
            thunkConfig.dispatch(getRixScenario());
            thunkConfig.dispatch(getCompensations());
            return response;
        } catch (err){
            return thunkConfig.rejectWithValue(err.response.data)
        }
    }
)

export const saveOrUpdateRiSimulation = createAsyncThunk(
    'saveOrUpdateRiSimulation',
    async ({rixScenario},thunkConfig) => {
        try {
            const response =   await postApi('saveOrUpdateRiSimulation','',rixScenario);
            thunkConfig.dispatch(setRixScenario(rixScenario));
            return response;
        } catch (err){
            return thunkConfig.rejectWithValue(err.response.data)
        }
    }
)

export const getProfileMfaData =  createAsyncThunk(
    'getProfileMfaData',
    async (_, {rejectWithValue}) => {
        try {
            const response =   await getApi('getProfileMfaData','');
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const setAlwaysChallengeMfa = createAsyncThunk(
    'setAlwaysChallengeMfa',
    async ({alwaysChallenge},thunkConfig) => {
        try {
            const requestBody = {
                alwaysChallenge: alwaysChallenge
            }

            const response = await postApi('setAlwaysChallengeMfa', ``, requestBody);
            thunkConfig.dispatch(setAlwaysChallenge(alwaysChallenge));
            return response;
        } catch (err) {
            return thunkConfig.rejectWithValue(err.response.data)
        }
    })

export const getParticipantConsents =  createAsyncThunk(
    'getParticipantConsents',
    async (planNumber, {rejectWithValue}) => {
        try {
            const queryParam = "consentType=5&consentType=28&consentType=33&consentType=34&&consentType=35&&consentType=23&&consentType=24&&consentType=25&&consentType=51&&consentType=52&&consentType=30&&consentType=57&&consentType=58&&consentType=62"
            const response =   await getApi('getParticipantConsents',`?planNumber=${planNumber}&${queryParam}`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }
    }
)

export const getTaxRateBrackets =  createAsyncThunk(
    'getTaxRateBrackets',
    async (_,{ rejectWithValue }) => {
        try {
            const response =   await getApi('getTaxRateBrackets','');
            return response;
        } catch (err){
            return rejectWithValue(err.response.data);
        }
    }
)

export const getOtherRetirementPlansData =  createAsyncThunk(
    'getOtherRetirementPlansData',
    async (planNumber, { rejectWithValue }) => {
        try {
            const response =   await getApi('getOtherRetirementPlansData',`?planNumber=${planNumber}`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }

    }
)

export const showOrHideOtherRetirementPlans  = createAsyncThunk(
    'showOrHideOtherRetirementPlans',
    async ({savePreferences},thunkConfig) => {
        try {
            const response =   await postApi('showOrHideOtherRetirementPlans','',savePreferences);
            thunkConfig.dispatch(setShowOldRetirementplans(!savePreferences.oldPlans))
            return response;
        } catch (err){
            return thunkConfig.rejectWithValue(err.response.data)
        }
    }
)

export const savePreferencesAndSubscriptions  = createAsyncThunk(
    'savePreferencesAndSubscriptions',
    async ({ serviceAndRequest },thunkConfig) => {
        const services = []
        for (let [key, value] of Object.entries(serviceAndRequest)) {
            if(value)
                services.push(key);
        }
        console.log("slice save--",serviceAndRequest)
        const result =[];
        await Promise.all(services.map(async (service) => {
            switch (service) {
                case "addConsents":
                    try {
                        const response = await postApi('savePreferencesAndSubscriptionConsents', '', serviceAndRequest.addConsents);
                        setAddConsentRequestData([]);
                        result.push(true)
                    } catch (err) {
                        result.push(false)
                    }
                    break;
                case "updateServiceStatusDaily":
                    try {
                        const response = await putApi('updateServiceStatus', '', serviceAndRequest.updateServiceStatusDaily);
                        result.push(true)
                    } catch (err) {
                        result.push(false)
                    }
                    break;
                case "updateServiceStatusMonthly":
                    try {
                        const response = await putApi('updateServiceStatus', '', serviceAndRequest.updateServiceStatusMonthly);
                        result.push(true)
                    } catch (err) {
                        result.push(false)
                    }
                    break;
                case "updateServiceProductsDaily":
                    try {
                        const response = await putApi('updateServiceProducts','',serviceAndRequest.updateServiceProductsDaily);
                        result.push(true)
                    } catch (err){
                        result.push(false)
                    }
                    break;
                case "updateServiceProductsMonthly":
                    try {
                        const response = await putApi('updateServiceProducts','',serviceAndRequest.updateServiceProductsMonthly);
                        result.push(true)
                    } catch (err){
                        result.push(false)
                    }
                    break;
                case "deleteServiceStatusDaily":
                    try {
                        const response = await deleteApi('deleteServiceStatus','',serviceAndRequest.deleteServiceStatusDaily);
                        result.push(true)
                    } catch (err){
                        result.push(false)
                    }
                    break;
                case "deleteServiceStatusMonthly":
                    try {
                        const response = await deleteApi('deleteServiceStatus','',serviceAndRequest.deleteServiceStatusMonthly);
                        result.push(true)
                    } catch (err){
                        result.push(false)
                    }
                    break;
            }
        }))
        if(!result.includes(false))
        {
            thunkConfig.dispatch(setIsShowSaveModal(true))
        }
        if(result.includes(false))
        {
            thunkConfig.dispatch(setIsSavePrefAndSubCallRejected(true))
        }


    }
)

export const getServiceStatus =  createAsyncThunk(
    'getServiceStatus',
    async (planNumber, {rejectWithValue}) => {
        try {
            const queryParam = "serviceOptionCode=20&serviceOptionCode=21"
            const response =   await getApi('getServiceStatus',`?planNumber=${planNumber}&${queryParam}`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }
    }
)

export const getPlanProducts =  createAsyncThunk(
    'getPlanProducts',
    async (planNumber, {rejectWithValue}) => {
        const requestBody = {
            "filterFrozenFund": true,
            "filterExcludedFund": true,
            "filterNoTicker":true,
            "excludeGlobalAssetClasses": [
                "ALL PRODUCTS"
            ],
            "planNumber": planNumber
        }
        try {
            const response =   await postApi('getPlanProducts','',requestBody);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }
    }
)

export const getServiceProducts =  createAsyncThunk(
    'getServiceProducts',
    async (planNumber, {rejectWithValue}) => {
        try {
            const queryParam = "serviceOptionCode=20&serviceOptionCode=21"
            const response =   await getApi('getServiceProducts',`?planNumber=${planNumber}&${queryParam}`);
            return response;
        } catch (err){
            return rejectWithValue(err.response.data)
        }
    }
)

const personalInformationSlice = createSlice<PersonalInformationState,{},"profile"> ({
    name:"profile",
    initialState:initialState ,
    reducers: {
        setIsPlansInfoDataLoaded(state,action: PayloadAction<any>){
            state.isPlansInfoDataLoaded = action.payload;
        },
        setSelectedPlanNumber(state,action: PayloadAction<any>){
            state.selectedPlan = action.payload;
        },
        setMobileNumber(state,action: PayloadAction<any>){
            state.mobileNumberObject.mobileNumber = action.payload;
        },
        setUpdatedMobileNumber(state,action: PayloadAction<any>){
            state.mobileNumberObject.updatedMobileNumber = action.payload;
        },
        setMobileNumberValid(state,action: PayloadAction<any>){
            state.mobileNumberObject.mobileNumberValid = action.payload;
        },
        setIsEditMobileMode(state,action: PayloadAction<any>){
            state.mobileNumberObject.isEditMobileMode = action.payload;
        },
        setEmailAddress(state,action: PayloadAction<any>){
            state.emailAddressObject.emailAddressData.emailAddress = action.payload;
        },
        setUpdatedEmailAddress(state,action: PayloadAction<any>){
            state.emailAddressObject.updatedEmailAddress = action.payload;
        },
        setIsEditEmailMode(state,action: PayloadAction<any>){
            state.emailAddressObject.isEditEmailMode = action.payload;
        },
        setEmailAddressValid(state,action: PayloadAction<any>){
            state.emailAddressObject.emailAddressValid = action.payload;
        },
        setIsEditAboutYourselfData(state, action: PayloadAction<any>) {
            state.aboutYourselfData.isEditAboutYourselfData = action.payload;
        },
        setUpdatedGender(state, action: PayloadAction<any>) {
            state.aboutYourselfData.updatedGender = action.payload;
        },
        setUpdatedInvExpLevel(state, action: PayloadAction<any>) {
            state.aboutYourselfData.updatedInvestmentExpLevel = action.payload;
        },
        setUpdatedInvestmentGoals(state, action: PayloadAction<any>) {
            state.aboutYourselfData.updatedInvestmentGoals = action.payload;
        },
        setIsActivationCodeLoaded(state, action: PayloadAction<any>) {
            state.mobileNumberObject.isActivationCodeLoaded = action.payload;
        },
        setIsSubmitActivationCodeLoaded(state, action: PayloadAction<any>) {
            state.mobileNumberObject.isSubmitActivationCodeLoaded = action.payload;
        },
        setShowSignUpForTextAlertsButton(state, action: PayloadAction<any>) {
            state.mobileNumberObject.showSignUpForTextAlertsButton = action.payload;
        },
        setIsEditSubscriptionEmail(state,action: PayloadAction<any>){
            state.emailAddressObject.isEditSubscriptionEmail = action.payload;
        },
        setUpdatedSubscriptionEmail(state,action: PayloadAction<any>){
            state.emailAddressObject.updatedSubscriptionEmail= action.payload;
        },
        setIsSubscriptionEmailValid(state,action: PayloadAction<any>){
            state.emailAddressObject.isSubscriptionEmailValid= action.payload;
        },
        setIsSubscriptionEmailError(state, action: PayloadAction<any>){
            state.emailAddressObject.isSubscriptionEmailError = action.payload;
        },
        setIsEmailAddressError(state, action: PayloadAction<any>){
            state.emailAddressObject.isEmailAddressError = action.payload;
        },
        setIsEmailNotOnFileError(state, action: PayloadAction<any>){
            state.emailAddressObject.isEmailNotOnFileError = action.payload;
        },
        setAlwaysChallenge(state, action: PayloadAction<any>){
            state.alwaysChallenge = action.payload;
        },
        setClientProfile(state, action: PayloadAction<any>) {
            state.clientProfile = action.payload;
        },
        setRixScenario(state, action: PayloadAction<any>) {
            state.planningInformation.retirementIncomeScenario = {
                ...state.planningInformation.retirementIncomeScenario,
                retirementStartAge: action.payload.retirementStartAge
            };
        },
        setIsEditPlanInfoMode(state, action: PayloadAction<any>) {
            state.planningInformation.isEditPlanInfoMode = action.payload;
        },
        setUpdatedAnnualSalary(state, action: PayloadAction<any>) {
            state.planningInformation.updatedAnnualSalary = action.payload;
        },
        setUpdatedRetirementAge(state, action: PayloadAction<any>) {
            state.planningInformation.updatedRetirementAge = action.payload;
        },
        setUpdatedMarginalTaxRate(state, action: PayloadAction<any>) {
            state.planningInformation.updatedMarginalTaxRate = action.payload;
        },
        setUpdatedPaycheckFrequency(state, action: PayloadAction<any>) {
            state.planningInformation.updatedPaycheckFrequency = action.payload;
        },
        setIsAnnualSalaryError(state, action: PayloadAction<any>) {
            state.planningInformation.isAnnualSalaryError = action.payload;
        },
        setIsRetirementAgeError(state, action: PayloadAction<any>) {
            state.planningInformation.isRetirementAgeError = action.payload;
        },
        setIsMarginalTaxRateError(state, action: PayloadAction<any>) {
            state.planningInformation.isMarginalTaxRateError = action.payload;
        },
        setCompensations(state, action: PayloadAction<any>) {
            state.planningInformation.retirementIncomeScenario = {
                ...state.planningInformation.retirementIncomeScenario,
                compensations: action.payload
            };
        },
        setIsSempraPlan(state, action: PayloadAction<any>){
            state.isSempraPlan = action.payload;
        },
        setShowOldRetirementplans(state, action: PayloadAction<any>) {
            state.otherRetirementPlanData = {
                ...state.otherRetirementPlanData,
                showOldRetirementPlans : action.payload
            };
        },
        setIsPricesInvOptionsChecked(state, action: PayloadAction<any>) {
            state.isPricesInvOptionsChecked = action.payload;
        },
        setSelectedPricesServiceProducts(state, action: PayloadAction<any>) {
            state.selectedPricesServiceProducts = action.payload;
        },
        setIsPerformanceInvOptionsChecked(state, action: PayloadAction<any>) {
            state.isPerformanceInvOptionsChecked = action.payload;
        },
        setSelectedPerformanceServiceProducts(state, action: PayloadAction<any>) {
            state.selectedPerformanceServiceProducts = action.payload;
        },
        setIsDailyPricesInvestmentError(state, action: PayloadAction<any>) {
            state.isDailyPricesInvestmentError = action.payload;
        },
        setIsMonthlyPerformanceInvestmentError(state, action: PayloadAction<any>) {
            state.isMonthlyPerformanceInvestmentError = action.payload;
        },
        setUserPreferencesData(state, action: PayloadAction<any>) {
            state.userPreferences = action.payload;
        },
        setDailyPricesInvOption(state, action: PayloadAction<any>) {
            state.dailyPricesInvOption = action.payload;
        },
        setMonthlyPerformanceInvOption(state, action: PayloadAction<any>) {
            state.monthlyPerformanceInvOption = action.payload;
        },
        setAddConsentRequestData(state, action: PayloadAction<any>){
            state.addConsentRequestData = action.payload;
        },
        setServiceStatusDailyPricesRequestData(state, action: PayloadAction<any>){
            state.serviceStatusDailyPricesRequestData = action.payload;
        },
        setServiceProductDailPricesRequestData(state, action: PayloadAction<any>){
            state.serviceProductDailyPricesRequestData = action.payload;
        },
        setServiceStatusMonthlyPerformanceRequestData(state, action: PayloadAction<any>){
            state.serviceStatusMonthlyPerformanceRequestData = action.payload;
        },
        setServiceProductMonthlyPerformanceData(state, action: PayloadAction<any>){
            state.serviceProductMonthlyPerformanceRequestData = action.payload;
        },
        setSaveDailyPricesPreferences(state, action: PayloadAction<any>){
            state.saveDailyPricesPreferences = action.payload;
        },
        setSaveMonthlyPerformancePreferences(state, action: PayloadAction<any>){
            state.saveMonthlyPerformancePreferences = action.payload;
        },
        setPutServiceCallForDailyPrices(state, action: PayloadAction<any>){
            state.putServiceCallForDailyPrices = action.payload;
        },
        setPutServiceCallForMonthlyPerformance(state, action: PayloadAction<any>){
            state.putServiceCallForMonthlyPerformance = action.payload;
        },
        setDeleteServiceCallForDailyPrices(state, action: PayloadAction<any>){
            state.deleteServiceCallForDailyPrices = action.payload;
        },
        setDeleteServiceCallForMonthlyPerformance(state, action: PayloadAction<any>){
            state.deleteServiceCallForMonthlyPerformance = action.payload;
        },
        setSaveDailyPricesInvestmentOptions(state, action: PayloadAction<any>){
            state.saveDailPricesInvestmentOptions = action.payload;
        },
        setSaveMonthlyPerformanceInvestmentOptions(state, action: PayloadAction<any>){
            state.saveMonthlyPerformanceInvestmentOptions = action.payload;
        },
        setIsDeleteServicesStatusRejectDataLoaded(state, action: PayloadAction<any>){
            state.isDeleteServiceStatusRejectDataLoaded = action.payload;
        },
        setIsShowSaveModal(state, action: PayloadAction<any>){
            state.isShowSaveModal = action.payload;
        },
        setRefreshPreferencesAndSubscription(state, action: PayloadAction<any>){
            state.refreshPreferencesAndSubscription = action.payload;
        },
        setIsSavePrefAndSubCallRejected(state, action: PayloadAction<any>){
            state.isSavePrefAndSubCallRejected = action.payload;
        },
        setIsSignUpForTextAlerts(state, action: PayloadAction<any>){
            state.mobileNumberObject.isShowToggleButton = action.payload;
        },
        setIsUpdatePhoneNumberLoaded(state, action: PayloadAction<any>){
            state.mobileNumberObject.isUpdatePhoneNumberLoaded = action.payload;
        },
        setIsSavePhoneNumberLoaded(state, action: PayloadAction<any>){
            state.mobileNumberObject.isSavePhoneNumberLoaded = action.payload;
        },
        setNavigateToPreferencesAndSubscription(state, action: PayloadAction<any>){
            state.navigateToPreferencesAndSubscription = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getPersonalInformationData.pending, (state, action) => {
                if (state.loading === 'idle') {
                    state.loading = 'pending'
                }
                state.isPersonalInformationDataLoadedRejected = false;
            })
            .addCase(getPersonalInformationData.fulfilled, (state, action) => {
                if (
                    state.loading === 'pending'
                ) {
                    state.loading = 'idle'
                    state.personalInformationData= action.payload;
                    state.isPersonalInformationDataLoaded = true;
                }
                state.isPersonalInformationDataLoadedRejected = false;
            })
            .addCase(getPersonalInformationData.rejected, (state, action) => {
                const { requestId } = action.meta
                if (
                    state.loading === 'pending' &&
                    state.currentRequestId === requestId
                ) {
                    state.loading = 'idle'
                    state.currentRequestId = undefined
                }
                state.isPersonalInformationDataLoadedRejected = true;
            })

            .addCase(getPlansData.pending, (state, action) => {
                state.isPlansDataLoaded = false;
            })
            .addCase(getPlansData.fulfilled, (state, action) => {
                state.plansData = action.payload;
                state.selectedPlan = {
                    label: state.plansData[0].planName,
                    value: state.plansData[0].planNumber
                }
                state.isPlansDataLoaded = true;
            })
            .addCase(getPlansData.rejected, (state, action) => {
                state.isPlansDataLoaded = false;
            })

            .addCase(getPhoneNumber.pending, (state, action) => {
                state.mobileNumberObject.isGetPhoneNumberLoaded = false;
            })
            .addCase(getPhoneNumber.fulfilled, (state, action) => {
                state.mobileNumberObject.mobileNumberData = action.payload;
                state.mobileNumberObject.mobileNumber = state.mobileNumberObject.mobileNumberData.participantPhoneNumber;
                state.mobileNumberObject.showSignUpForTextAlertsButton = state.mobileNumberObject.mobileNumberData.activatedFlag;
                state.mobileNumberObject.isGetPhoneNumberLoaded = true;
            })
            .addCase(getPhoneNumber.rejected, (state, action) => {
                state.mobileNumberObject.isGetPhoneNumberLoaded = false;
                state.mobileNumberObject.isGetPhoneNumberLoadedRejected = true;
            })

            .addCase(updatePhoneNumber.pending, (state, action) => {
                state.mobileNumberObject.isUpdatePhoneNumberLoaded = false;
            })
            .addCase(updatePhoneNumber.fulfilled, (state, action) => {
                state.mobileNumberObject.isUpdatePhoneNumberLoaded = true;
                state.mobileNumberObject.mobileNumberData = action.payload;
                state.mobileNumberObject.showSignUpForTextAlertsButton = state.mobileNumberObject.mobileNumberData.activatedFlag;
            })
            .addCase(updatePhoneNumber.rejected, (state, action) => {
                state.mobileNumberObject.isUpdatePhoneNumberLoaded = false;
                state.mobileNumberObject.isUpdatePhoneNumberRejected = true;
            })
            .addCase(savePhoneNumber.pending, (state, action) => {
                state.mobileNumberObject.isSavePhoneNumberLoaded = false;
            })
            .addCase(savePhoneNumber.fulfilled, (state, action) => {
                state.mobileNumberObject.isSavePhoneNumberLoaded = true;
                state.mobileNumberObject.mobileNumberData = action.payload;
                state.mobileNumberObject.showSignUpForTextAlertsButton = state.mobileNumberObject.mobileNumberData.activatedFlag;
            })
            .addCase(savePhoneNumber.rejected, (state, action) => {
                state.mobileNumberObject.isSavePhoneNumberLoaded = false;
                state.mobileNumberObject.isSavePhoneNumberRejected = true;
            })

            .addCase(getActivationCode.pending, (state, action) => {
                state.mobileNumberObject.isActivationCodeLoaded = false;
            })
            .addCase(getActivationCode.fulfilled, (state, action) => {
                state.mobileNumberObject.isActivationCodeLoaded = true;
                state.mobileNumberObject.isSubmitActivationCodeRejected = false;
            })
            .addCase(getActivationCode.rejected, (state, action) => {
                state.mobileNumberObject.isActivationCodeLoaded = false;
            })

            .addCase(submitActivationCode.pending, (state, action) => {
                state.mobileNumberObject.isSubmitActivationCodeLoaded = false;
            })
            .addCase(submitActivationCode.fulfilled, (state, action) => {
                state.mobileNumberObject.isSubmitActivationCodeLoaded = true;
                state.mobileNumberObject.isShowToggleButton = true;
                const profileAlert = state.participantConsentData.find((consent: any) => consent.consentType === "52");
                const transactionalAlert = state.participantConsentData.find((consent: any) => consent.consentType === "51");
                profileAlert.consentIndicator = false;
                transactionalAlert.consentIndicator = false;
            })
            .addCase(submitActivationCode.rejected, (state, action) => {
                state.mobileNumberObject.isSubmitActivationCodeLoaded = false;
                state.mobileNumberObject.isSubmitActivationCodeRejected = true;
            })

            .addCase(getEmailAddress.pending, (state, action) => {
                state.emailAddressObject.isGetEmailAddressLoaded = false;
                state.emailAddressObject.isGetEmailAddressLoadedRejected = false;
            })
            .addCase(getEmailAddress.fulfilled, (state, action) => {
                state.emailAddressObject.emailAddressData = action.payload;
                state.emailAddressObject.isGetEmailAddressLoaded = true;
                state.emailAddressObject.isGetEmailAddressLoadedRejected = false;
            })
            .addCase(getEmailAddress.rejected, (state, action) => {
                state.emailAddressObject.isGetEmailAddressLoaded = false;
                state.emailAddressObject.isGetEmailAddressLoadedRejected = true;
            })
            .addCase(updateEmailAddress.pending, (state, action) => {
                state.emailAddressObject.isUpdateEmailAddressLoaded = false;
            })
            .addCase(updateEmailAddress.fulfilled, (state, action) => {
                state.emailAddressObject.isUpdateEmailAddressLoaded = true;
            })
            .addCase(updateEmailAddress.rejected, (state, action) => {
                state.emailAddressObject.isUpdateEmailAddressLoaded = false;
                state.emailAddressObject.isUpdateEmailAddressRejected = true;
            })
            .addCase(getPlanProfileOlaMessageData.pending, (state, action) => {
                state.isPlanProfileOlaMessageDataLoaded = false;
                state.isPlanProfileOlaMessageDataLoadedRejected = false;
            })
            .addCase(getPlanProfileOlaMessageData.fulfilled, (state, action) => {
                state.planProfileOlaMessageData = action.payload;
                state.isPlanProfileOlaMessageDataLoaded = true;
                state.isPlanProfileOlaMessageDataLoadedRejected = false;
            })
            .addCase(getPlanProfileOlaMessageData.rejected, (state, action) => {
                state.isParticipantTerminateOlaMessageDataLoaded = false;
                state.isPlanProfileOlaMessageDataLoadedRejected = true;
            })
            .addCase(getSempraActivePlanNameOlaMsg.pending, (state, action) => {
                state.isSempraActivePlanNameOlaMsgDataLoaded = false;
                state.isSempraActivePlanNameOlaMsgDataLoadedRejected = false;
            })
            .addCase(getSempraActivePlanNameOlaMsg.fulfilled, (state, action) => {
                state.sempraActivePlanNameOlaMsg = action.payload;
                state.isSempraActivePlanNameOlaMsgDataLoaded = true;
                state.isSempraActivePlanNameOlaMsgDataLoadedRejected = false;
            })
            .addCase(getSempraActivePlanNameOlaMsg.rejected, (state, action) => {
                state.isSempraActivePlanNameOlaMsgDataLoaded = false;
                state.isSempraActivePlanNameOlaMsgDataLoadedRejected = true;
            })
            .addCase(getSempraTerminatedPlanNameOlaMsg.pending, (state, action) => {
                state.isSempraTerminatedPlanNameOlaMsgDataLoaded = false;
                state.isSempraTerminatedPlanNameOlaMsgDataLoadedRejected = false;
            })
            .addCase(getSempraTerminatedPlanNameOlaMsg.fulfilled, (state, action) => {
                state.sempraTerminatedPlanNameOlaMsg = action.payload;
                state.isSempraTerminatedPlanNameOlaMsgDataLoaded = true;
                state.isSempraTerminatedPlanNameOlaMsgDataLoadedRejected = false;
            })
            .addCase(getSempraTerminatedPlanNameOlaMsg.rejected, (state, action) => {
                state.isSempraTerminatedPlanNameOlaMsgDataLoaded = false;
                state.isSempraTerminatedPlanNameOlaMsgDataLoadedRejected = true;
            })
            .addCase(getParticipantTerminateOlaMessageData.pending, (state, action) => {
                state.isParticipantTerminateOlaMessageDataLoaded = false;
                state.isParticipantTerminateOlaMessageDataLoadedRejected = false;
            })
            .addCase(getParticipantTerminateOlaMessageData.fulfilled, (state, action) => {
                state.participantTerminateOlaMessageData = action.payload;
                state.isParticipantTerminateOlaMessageDataLoaded = true;
                state.isParticipantTerminateOlaMessageDataLoadedRejected = false;
            })
            .addCase(getParticipantTerminateOlaMessageData.rejected, (state, action) => {
                state.isParticipantTerminateOlaMessageDataLoaded = false;
                state.isParticipantTerminateOlaMessageDataLoadedRejected = true;
            })
            .addCase(getPlansInfoData.pending, (state, action) => {
                state.isPlansInfoDataLoaded = false;
                state.isPlansInfoDataLoadedRejected = false;
            })
            .addCase(getPlansInfoData.fulfilled, (state, action) => {
                state.plansInfoData = action.payload;
                state.isPlansInfoDataLoaded = true;
                state.isPlansInfoDataLoadedRejected = false;
            })
            .addCase(getPlansInfoData.rejected, (state, action) => {
                state.isPlansInfoDataLoaded = false;
                state.isPlansInfoDataLoadedRejected = true;
            })
            .addCase(getPlansRulesData.pending, (state, action) => {
                state.isPlansRulesDataLoaded = false;
                state.isPlansRulesDataLoadedRejected = false;
            })
            .addCase(getPlansRulesData.fulfilled, (state, action) => {
                state.plansRulesData = action.payload;
                state.isPlansRulesDataLoaded = true;
                state.isPlansRulesDataLoadedRejected = false;
            })
            .addCase(getPlansRulesData.rejected, (state, action) => {
                state.isPlansRulesDataLoaded = false;
                state.isPlansRulesDataLoadedRejected = true;
            })
            .addCase(getBeneMcCAmishSwitchData.pending, (state, action) => {
                state.isBeneMcCAmishSwitchDataLoaded = false;
                state.isBeneMcCAmishSwitchDataLoadedRejected = false;
            })
            .addCase(getBeneMcCAmishSwitchData.fulfilled, (state, action) => {
                state.beneMcCAmishSwitchData = action.payload;
                state.isBeneMcCAmishSwitchDataLoaded = true;
                state.isBeneMcCAmishSwitchDataLoadedRejected = false;
            })
            .addCase(getBeneMcCAmishSwitchData.rejected, (state, action) => {
                state.isBeneMcCAmishSwitchDataLoaded = false;
                state.isBeneMcCAmishSwitchDataLoadedRejected = true;
            })
            .addCase(getParticipantBeneficiaryData.pending, (state, action) => {
                state.isParticipantBeneficiaryDataLoaded = false;
            })
            .addCase(getParticipantBeneficiaryData.fulfilled, (state, action) => {
                state.participantBeneficiaryData = action.payload;
                state.isParticipantBeneficiaryDataLoaded = true;
            })
            .addCase(getParticipantBeneficiaryData.rejected, (state, action) => {
                state.isParticipantBeneficiaryDataLoaded = false;
                state.isParticipantBeneficiaryDataRejected = true;
            })
            .addCase(getDefinedBenefitParticipantBeneficiariesData.pending, (state, action) => {
                state.isDefinedBenefitParticipantBeneficiariesDataLoaded = false;
                state.isDefinedBenefitParticipantBeneficiariesDataLoadedRejected = false;
            })
            .addCase(getDefinedBenefitParticipantBeneficiariesData.fulfilled, (state, action) => {
                state.definedBenefitParticipantBeneficiariesData = action.payload;
                state.isDefinedBenefitParticipantBeneficiariesDataLoaded = true;
                state.isDefinedBenefitParticipantBeneficiariesDataLoadedRejected = false;
            })
            .addCase(getDefinedBenefitParticipantBeneficiariesData.rejected, (state, action) => {
                state.isDefinedBenefitParticipantBeneficiariesDataLoaded = false;
                state.isDefinedBenefitParticipantBeneficiariesDataLoadedRejected = true;
            })
            .addCase(getClientProfile.pending, (state, action) => {
                state.isClientProfileLoaded = false;
            })
            .addCase(getClientProfile.fulfilled, (state, action) => {
                state.clientProfile = action.payload;
                state.aboutYourselfData.updatedGender = action.payload.genderType;
                state.aboutYourselfData.updatedInvestmentExpLevel = action.payload.financialExperienceLevelType;
                state.aboutYourselfData.updatedInvestmentGoals = action.payload.investmentsGoals;
                state.planningInformation.updatedMarginalTaxRate = action.payload.attributes?.find((attribute: any) =>
                    attribute.attributeType.typeCd === "MTRT"
                )?.amount;
                state.isClientProfileLoaded = true;
            })
            .addCase(getClientProfile.rejected, (state, action) => {
                state.isClientProfileLoaded = false;
                state.isClientProfileRejectedDataLoaded = true;
            })
            .addCase(saveOrUpdateClientProfile.pending, (state, action) => {
                state.isSaveOrUpdateClientProfileLoaded = false;
            })
            .addCase(saveOrUpdateClientProfile.fulfilled, (state, action) => {
                state.isSaveOrUpdateClientProfileLoaded = true;
            })
            .addCase(saveOrUpdateClientProfile.rejected, (state, action) => {
                state.isSaveOrUpdateClientProfileLoaded = false;
                state.isSaveOrUpdateClientProfileRejected = true;
            })
            .addCase(getReferenceTypeValues.pending, (state, action) => {
                state.aboutYourselfData.isGetReferenceTypeValuesLoaded = false;
            })
            .addCase(getReferenceTypeValues.fulfilled, (state, action) => {
                if(action.payload[0].typeIdentifier === 52)
                    state.aboutYourselfData.investmentExpOptions = action.payload;
                if(action.payload[0].typeIdentifier === 53)
                    state.aboutYourselfData.investmentGoalOptions = action.payload;
                if(action.payload[0].typeIdentifier === 64)
                    state.planningInformation.paycheckFrequencyOptions = action.payload;
                state.aboutYourselfData.isGetReferenceTypeValuesLoaded = true;
            })
            .addCase(getReferenceTypeValues.rejected, (state, action) => {
                state.aboutYourselfData.isGetReferenceTypeValuesLoaded = false;
                state.aboutYourselfData.isGetReferenceTypeValuesLoadedRejected = true;
            })
            .addCase(getProfileMfaData.pending, (state, action) => {
                state.isProfileMfaDataLoaded = false;
            })
            .addCase(getProfileMfaData.fulfilled, (state, action) => {
                state.alwaysChallenge = action.payload.alwaysChallenge;
                state.isProfileMfaDataLoaded = true;
            })
            .addCase(getProfileMfaData.rejected, (state, action) => {
                state.isProfileMfaDataLoaded = false;
                state.isProfileMfaDataRejected = true;
            })
            .addCase(getParticipantConsents.pending, (state, action) => {
                state.isParticipantConsentDataLoaded = false;
            })
            .addCase(getParticipantConsents.fulfilled, (state, action) => {
                state.participantConsentData = action.payload;
                state.isParticipantConsentDataLoaded = true;
            })
            .addCase(getParticipantConsents.rejected, (state, action) => {
                state.isParticipantConsentDataLoaded = false;
                state.isParticipantConsentDataRejected = true;
            })
            .addCase(getTaxRateBrackets.pending, (state, action) => {
                state.isTaxRateBracketsDataLoaded = false;
            })
            .addCase(getTaxRateBrackets.fulfilled, (state, action) => {
                state.taxRateBrackets = action.payload;
                state.isTaxRateBracketsDataLoaded = true;
            })
            .addCase(getTaxRateBrackets.rejected, (state, action) => {
                state.isTaxRateBracketsDataRejected = true;
            })
            .addCase(getRixScenario.pending, (state, action) => {
            state.planningInformation.isRixScenarioLoaded = false;
            })
            .addCase(getRixScenario.fulfilled, (state, action) => {
                state.planningInformation.retirementIncomeScenario = action.payload;
                state.planningInformation.updatedRetirementAge = action.payload?.retirementStartAge;
                const filteredCompensations = action.payload?.compensations && action.payload?.compensations.filter((comp: any) => action.payload?.participantProfile?.bpId == comp.bpId);
                state.planningInformation.updatedAnnualSalary = filteredCompensations && filteredCompensations.length > 1 ? filteredCompensations.reduce((a,b) => { return a + b.amount}, 0) : filteredCompensations && filteredCompensations.length === 1 ? filteredCompensations && filteredCompensations[0].amount : 0.0;
                state.planningInformation.isRixScenarioLoaded = true;
            })
            .addCase(getRixScenario.rejected, (state, action) => {
                state.planningInformation.isRixScenarioLoaded = false;
                state.planningInformation.isRixScenarioRejectedDataLoaded = true;
            })
            .addCase(getCompensations.pending, (state, action) => {
                state.planningInformation.compensationsDataLoaded = false;
            })
            .addCase(getCompensations.fulfilled, (state, action) => {
                state.planningInformation.compensations = action.payload;
                state.planningInformation.multiClientCompensation = action.payload && action.payload.length > 1;
                state.planningInformation.compensationsDataLoaded = true;
            })
            .addCase(getCompensations.rejected, (state, action) => {
                state.planningInformation.compensationsDataRejected = true;
            })
            .addCase(updateCompensations.pending, (state, action) => {
                state.planningInformation.isUpdateCompensationsLoaded = false;
            })
            .addCase(updateCompensations.fulfilled, (state, action) => {
                state.planningInformation.isUpdateCompensationsLoaded = true;
            })
            .addCase(updateCompensations.rejected, (state, action) => {
                state.planningInformation.isUpdateCompensationsLoaded = false;
                state.planningInformation.isUpdateCompensationsRejected = true;
            })

            .addCase(saveRixSalaryPayFrequency.pending, (state, action) => {
                state.planningInformation.isSaveRixSalaryPayFrequencyLoaded = false;
            })
            .addCase(saveRixSalaryPayFrequency.fulfilled, (state, action) => {
                state.planningInformation.isSaveRixSalaryPayFrequencyLoaded = true;
            })
            .addCase(saveRixSalaryPayFrequency.rejected, (state, action) => {
                state.planningInformation.isSaveRixSalaryPayFrequencyLoaded = false;
                state.planningInformation.isSaveRixSalaryPayFrequencyRejected = true;
            })

            .addCase(saveOrUpdateRiSimulation.pending, (state, action) => {
                state.planningInformation.isSaveOrUpdateRiSimulationLoaded = false;
            })
            .addCase(saveOrUpdateRiSimulation.fulfilled, (state, action) => {
                state.planningInformation.isSaveOrUpdateRiSimulationLoaded = true;
            })
            .addCase(saveOrUpdateRiSimulation.rejected, (state, action) => {
                state.planningInformation.isSaveOrUpdateRiSimulationLoaded = false;
                state.planningInformation.isSaveOrUpdateRiSimulationRejected = true;
            })
            .addCase(getOtherRetirementPlansData.pending, (state, action) => {
                state.isOtherRetirementPlanDataLoaded = false;
            })
            .addCase(getOtherRetirementPlansData.fulfilled, (state, action) => {
                state.isOtherRetirementPlanDataLoaded = true;
                state.otherRetirementPlanData = action.payload;
            })
            .addCase(getOtherRetirementPlansData.rejected, (state, action) => {
                state.isOtherRetirementPlanDataLoaded = false;
                state.isOtherRetirementPlanDataRejected = true;
            })
            .addCase(showOrHideOtherRetirementPlans.pending, (state, action) => {
                state.isShowOrHideOtherRetirementPlansLoaded = false;
            })
            .addCase(showOrHideOtherRetirementPlans.fulfilled, (state, action) => {
                state.isShowOrHideOtherRetirementPlansLoaded = true;
            })
            .addCase(showOrHideOtherRetirementPlans.rejected, (state, action) => {
                state.isShowOrHideOtherRetirementPlansLoaded = false;
                state.isShowOrHideOtherRetirementPlansRejected = true;
            })
            .addCase(getServiceStatus.pending, (state, action) => {
                state.isServiceStatusDataLoaded = false;
            })
            .addCase(getServiceStatus.fulfilled, (state, action) => {
                state.serviceStatus = action.payload;
                state.isServiceStatusDataLoaded = true;
            })
            .addCase(getServiceStatus.rejected, (state, action) => {
                state.isServiceStatusDataLoaded = false;
                state.isServiceStatusDataRejected = true;
            })
            .addCase(getPlanProducts.pending, (state, action) => {
                state.isPlanProductsDataLoaded = false;
            })
            .addCase(getPlanProducts.fulfilled, (state, action) => {
                state.filteredPlanProducts = action.payload;
                state.isPlanProductsDataLoaded = true;
            })
            .addCase(getPlanProducts.rejected, (state, action) => {
                state.isPlanProductsDataLoaded = false;
                state.isPlanProductsDataRejected = true;
            })
            .addCase(getServiceProducts.pending, (state, action) => {
                state.isServiceProductsDataLoaded = false;
            })
            .addCase(getServiceProducts.fulfilled, (state, action) => {
                state.serviceProducts = action.payload;
                state.isServiceProductsDataLoaded = true;
            })
            .addCase(getServiceProducts.rejected, (state, action) => {
                state.isServiceProductsDataLoaded = false;
                state.isServiceProductsDataRejected = true;
            })

    }
});



// //const personalInformationReducer = personalInformationSlice.reducer;
// const {action,reducer} = personalInformationSlice;
// export default reducer;
export const { setNavigateToPreferencesAndSubscription, setIsPlansInfoDataLoaded, setRefreshPreferencesAndSubscription, setIsSignUpForTextAlerts, setIsUpdatePhoneNumberLoaded, setIsSavePhoneNumberLoaded, setIsShowSaveModal, setIsSavePrefAndSubCallRejected,
    setIsDeleteServicesStatusRejectDataLoaded, setIssUpdateServiceProductsRejectDataLoaded, setSaveMonthlyPerformanceInvestmentOptions, setSaveDailyPricesInvestmentOptions,
    setDeleteServiceCallForMonthlyPerformance, setDeleteServiceCallForDailyPrices, setPutServiceCallForMonthlyPerformance, setPutServiceCallForDailyPrices,
    setSaveMonthlyPerformancePreferences, setSaveDailyPricesPreferences, setServiceProductMonthlyPerformanceData, setServiceStatusMonthlyPerformanceRequestData,
    setServiceProductDailPricesRequestData, setServiceStatusDailyPricesRequestData, setAddConsentRequestData, setDailyPricesInvOption, setMonthlyPerformanceInvOption,
    setShowOldRetirementplans, setIsEmailNotOnFileError, setShowSignUpForTextAlertsButton,setIsPricesInvOptionsChecked, setIsPerformanceInvOptionsChecked,
    setIsDailyPricesInvestmentError, setIsMonthlyPerformanceInvestmentError, setSelectedPricesServiceProducts, setSelectedPerformanceServiceProducts,
    setIsMarginalTaxRateError, setIsEmailAddressError, setSelectedPlanNumber,setIsActivationCodeLoaded,setIsSubmitActivationCodeLoaded,
    setMobileNumber,setUpdatedMobileNumber,setMobileNumberValid, setEmailAddress, setUpdatedEmailAddress, setEmailAddressValid,
    setIsEditMobileMode, setIsEditEmailMode, setIsEditAboutYourselfData, setUpdatedGender, setUpdatedInvExpLevel, setUpdatedInvestmentGoals,
    setIsEditSubscriptionEmail, setUpdatedSubscriptionEmail, setIsSubscriptionEmailValid, setIsSubscriptionEmailError, setAlwaysChallenge,
    setIsEditPlanInfoMode, setUpdatedAnnualSalary, setIsAnnualSalaryError, setIsRetirementAgeError, setUpdatedRetirementAge,
    setUpdatedMarginalTaxRate, setUpdatedPaycheckFrequency, setCompensations, setClientProfile, setRixScenario, setUserPreferencesData, setIsSempraPlan } = personalInformationSlice.actions
export default  personalInformationSlice.reducer;